export const STYLE_THEMES = {
  light: {
    textColor: "#000000",
    valueColor: "#000000",
    placeholderColor: "#999",
    labelColor: "#000000",
    groupColor: "#FF6666",
  },

  dark: {
    textColor: "#FFFFFF",
    valueColor: "#FFFFFF",
    placeholderColor: "#BBBBBB",
    labelColor: "#f8f4f4",
    groupColor: "#FFB3B3",
  },
};